import React from 'react';
import { useLocation } from 'react-router-dom';
import clsx from 'clsx';
import { useIsMobile } from '../../providers/IsMobileProvider';
import Logo from './Logo';
import styles from '../../styles/common/Header.module.scss';
import UserDropdownMenu from './UserDropdownMenu'

function Header() {
  const { isMobile } = useIsMobile();
  const location = useLocation();

  const navigateToPage = (path: string) => {
    window.location.href = path;
  };

  return (
    <header className={clsx(styles.cHeader, "c-header")}>

      <nav className="c-header-nav">
        <Logo displayBrandmark={isMobile}/>
        
        <div className="c-header-nav-links">
          <button 
            className={clsx("c-nav-link", location.pathname === "/" && "active")}
            onClick={() => navigateToPage('/')}
          >
            Credit Lines
          </button>
          <button 
            className={clsx("c-nav-link", location.pathname === "/transactions" && "active")}
            onClick={() => navigateToPage('/transactions')}
          >
            Transactions
          </button>
          <button 
            className={clsx("c-nav-link", location.pathname === "/whitelist" && "active")}
            onClick={() => navigateToPage('/whitelist')}
          >
            Whitelist
          </button>
          <UserDropdownMenu/>

        </div>
        
      </nav>

    </header>
  );
}

export default Header;